import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue'
import router from './router'
import HMCore, { setSeoConfig, setImgixConfig } from '@hatfieldmedia/hmcore'
import '@hatfieldmedia/hmcore/style.css'
import './styles/global.css'
import 'virtual:image-meta' // Initialize image metadata from images.meta.json
import 'virtual:video-meta' // Initialize video metadata from videos.meta.json
import 'virtual:org-schema' // Initialize organization schema.org data from org.schema.json
import App from './App.vue'

// Configure SEO defaults
// __SITE_BASE_URL__ is injected at build time by hmcore-deploy
declare const __SITE_BASE_URL__: string
const siteBaseUrl = typeof __SITE_BASE_URL__ !== 'undefined' ? __SITE_BASE_URL__ : 'https://your-domain.com'

setSeoConfig({
  baseUrl: siteBaseUrl,
  titleSuffix: ' | Sponsored Biomarker Testing',
})

// Configure imgix for image optimization
// __IMGIX_DOMAIN__ is injected at build time by hmcore-deploy from shared.tfvars
declare const __IMGIX_DOMAIN__: string
const imgixDomain = typeof __IMGIX_DOMAIN__ !== 'undefined' ? __IMGIX_DOMAIN__ : 'sarcomatesting.imgix.net'
if (imgixDomain) {
  setImgixConfig({ domain: imgixDomain })
}

const app = createApp(App)
const head = createHead()

app.use(createPinia())
app.use(router)
app.use(head)
app.use(HMCore)
app.mount('#app')
